export default __webpack_public_path__ + "static/deep_logo.inline-3f9d8b0e8428b044cddf7c81351c31c3.png";